import {
    APPLICATION_DETAIL_FAILED,
    APPLICATION_DETAIL_LOADDATA,
    APPLICATION_DETAIL_LOADING,
    APPLICATION_DETAIL_SUCCESS, APPLICATION_STAGE_LOADDATA, APPLICATION_STAGE_SUCCESS
} from "../constants/ApplicationdetailConst";


const initState = {
    loading: false,
    message: '',
    showMessage: false,
    id: 0,
    data: []
}

const applicationdetailreducer = (state = initState, action) => {
    switch (action.type) {
        case APPLICATION_DETAIL_LOADING:
            return {
                ...state,
                loading: true,
            }
        case APPLICATION_DETAIL_FAILED:
            return {
                ...state,
                message: action.message,
                showMessage: true,
                loading: false,
                stages_loading: false,
            }
        case APPLICATION_DETAIL_SUCCESS:
            return {
                ...state,
                showMessage: false,
                data:action.data,
                loading: false
            }
        case APPLICATION_DETAIL_LOADDATA:
            return {
                ...state,
                id:action.id,
                loading: true,
            }


        default:
            return state;
    }
}

export default applicationdetailreducer